import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/core/services/configuration/configuration.service';

@Component({
  selector: 'app-manage-evaluacion-modal',
  templateUrl: './manage-evaluacion-modal.component.html',
  styleUrls: ['./manage-evaluacion-modal.component.css']
})
export class ManageEvaluacionModalComponent implements OnInit {

  myForm: FormGroup;
  @Input() evaluacionId = 0;
  evaluacion: any;
  faTimes = faTimes;
  @Output() successEmit: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public formbuild          : FormBuilder,
    public activeModal        : NgbActiveModal,
    private configurationService	: ConfigurationService,
  ) {
    this.initForm();
   }

  ngOnInit(): void {
    if (this.evaluacionId) {
      this.obtenerEvaluacion();
    }
  }

  initForm() {
    this.myForm = this.formbuild.group({
      descripcion: [null, [Validators.required]]
    });
  }
  
  setForm(item) {
    for (const key in item) {
      if (this.myForm.controls[key]) {
        this.myForm.controls[key].setValue(item[key]);
      }
    }
  }

  obtenerEvaluacion() {
    this.configurationService.obtenerEvaluacion(this.evaluacionId)
    .then(res => {
      this.evaluacion = res;
      this.setForm(res);
    })
    .catch(error => {
      console.error(error);
    });
  }

  onSubmit() {
    if(this.myForm.valid) {
      const data = this.myForm.value;

      this.configurationService.guardarEvaluacion(this.myForm.value, this.evaluacionId)
      .then(res => {
        this.successEmit.emit();
        this.activeModal.close(true);
      }).
      catch(error => {
        this.activeModal.close(false);
      });
    }
  }

}
